import styled from 'styled-components';
import PendingPods from './PendingPods';
import { colorSchema } from 'utils/style';

export default styled(PendingPods)`
  .pending-pods {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(12, 1fr);
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;

    &__container {
      grid-column: 1 / span 12;
      grid-row: 1;
      padding: 0 2rem 6rem;
    }

    &__loading {
      display: flex;
      padding: 2rem 0;
      justify-content: center;
    }

    &__header {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      width: 140px;
    }

    &__id {
      color: ${colorSchema('grey900')};
      font-weight: 500;
      margin-bottom: 0.5rem;
    }

    &__body {
      display: flex;
      justify-content: space-between;

      & > div:nth-child(2) {
        flex-grow: 1;
      }
    }

    &__assignment-container {
      align-items: center;
      flex-basis: 30%;
      display: flex;
      justify-content: flex-end;
    }

    &__alert {
      display: flex;
      padding: 3.2rem;
    }
  }
`;
